import { CSInterface } from "csinterface-ts";
import { rootStore } from "../../store/root";
import { jsxConstFunctions, jsxConstsEvents } from "../jsxConsts";
const { csInterface }: { csInterface: CSInterface } = window as any;

export function alertListener() {
  const {
    uiStore: { addToAlertMessage, setAlertModalVisible },
  } = rootStore;
  csInterface.addEventListener(jsxConstsEvents.alert, (ev: any) => {
    if (ev.data.message) {
      const message = ev.data.message.replace("<br />", "\n");
      addToAlertMessage(message);
      setAlertModalVisible();
      csInterface.evalScript(jsxConstFunctions.cancelRender, (res) => {console.log('')});
    }
  });
  csInterface.addEventListener(jsxConstsEvents.console, (ev: any) => {
    if (typeof ev.data === 'string' && ev.data.indexOf("Permission denied") > -1) {
      csInterface.evalScript(jsxConstFunctions.cancelRender, (res) => {console.log('')});
      const message = ev.data.replace("<br />", "\n");
      addToAlertMessage(message);
      setAlertModalVisible();
    }
  });
}
